export default {
  "username.placeholder": "Please provide Username",
  "username.required": "Username is required",
  "password.placeholder": "Please provide Password",
  "password.required": "Password is required",
  "password.invalid": "Password is invalid",
  "email.invalid": "Email is invalid",
  "email.required": "Email Required",
  Logout: "Logout",
  changePassword: "Change Password",
  "Name.required": "Name is required ",
  "password.lengthinvalid": "Password must contain 8 characters",
  "delete.confirmation": "Are you sure you want to delete the",
  "Mobile.invalid": "Mobile number is invalid",
  "modal.delete": "Delete",
  "modal.edit": "Edit",
  "modal.add": "Add",
  "modal.update": "Update",
  "modal.cancel": "Cancel",
  "modal.yes": "Yes",
  "modal.no": "No",
  yes: "Yes",
  optionAIsCorrect: "Option A is Correct",
  question: "Question",
  optionA: "Option A",
  optionB: "Option B",
  optionC: "Option C",
  no: "No",
  "entityState.updateState": "Update Entity State",
  "entityState.addState": "Add Entity State",
  name: "Name",
  description: "Description",
  color: "Colour",
  mandatoryFields: "Mandatory Fields",
  update: "Update",
  add: "Add",
  view: "View",
  edit: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  close: "Close",
  default: "Default",
  active: "Active",
  quiz: "Quiz",
  quizQuestion: "Quiz Question",
  assessment: "Self Assessment",
  fromDate: "From Date",
  toDate: "To Date",
  user: "User",
  task: "Task",
  image: "Image",
  merchant: "Merchant",
  "add.homepageimage": "Add HomePage Image",
  "delete.homepageimage": "Delete HomePage Image",
  "update.homepageimage": "Update HomePage Image",
  "add.homepageimage.success": "HomePage Image Successfully Added",
  "delete.homepageimage.success": "HomePage Image Successfully Deleted",
  "update.homepageimage.success": "HomePage Image Successfully Updated",
  logo: "Logo",
  address: "Address",
  ageGroup: "Age Group",
  ageGroupTitle: "Age Group Title",
  ageLimit: "Age Limit",
  "user.mobileNumber": "Mobile Number",
  "user.conversionPoints": "Conversion Points",
  "user.conversionMoney": "Conversion Money",
  "user.spouseName": "Spouse Name",
  "user.hasNotification": "Notification",
  "user.quizPoint": "Quiz Point",
  "user.taskPoint": "Task Point",
  "user.assessmentPoint": "Self Assessment Point",
  "user.isRealMoneyUser": "Real Money User",
  "button.add": "Add",
  "button.update": "Update",
  "button.remove": "Delete",
  "button.cancel": "Cancel",
  "mandatory.fields": "Mandatory Fields",
  "Question.required": "Question is required",
  "Option A.required": "Option A is required",
  "Option B.required": "Option B is required",
  "Option C.required": "Option C is required",
  "FromDate.required": "From Date is required",
  "mobileNumber.required": "Mobile Number is required",
  "ToDate.required": "To Date is required",
  "ageGroupTitle.required": "Age Group Title is required",
  "description.required": "Description is required",
  "address.required": "Address is required",
  "logoURL.required": "Logo URL is required",
  "fieldUpload.error":
    "Uploading of photo failed. Kindly refresh and try again",
  "name.quizMaster": "Quiz Name",
  title: "Title",
  content: "Content",
  "home.cmsContent": "Home.CMS Content",
  cmsContent: "CMS Content",
  action: "Action",
  preview: "Preview",
  "QuizName.required": " Quiz name is required",
  "title.required": "Title is required",
  "content.required": "Content is required",

  //add.update,delete success
  "quizMaster.add": "Quiz Successfully Added",
  "quizMaster.update": "Quiz Successfully Updated",
  "quizMaster.delete": "Quiz Successfully Deleted",

  "taskMaster.add": "Task Successfully Added",
  "taskMaster.update": "Task Successfully Updated",
  "taskMaster.delete": "Task Successfully Deleted",

  "merchant.add": "Merchant Successfully Added",
  "merchant.update": "Merchant Successfully Updated",
  "merchant.delete": "Merchant Successfully Deleted",

  "quizQuestion.add": "Quiz Question Successfully Added",
  "quizQuestion.update": "Quiz Question Successfully Updated",
  "quizQuestion.delete": "Quiz Question Successfully Deleted",

  "quizSubQuestion.add": "Quiz Sub Question Successfully Added",
  "quizSubQuestion.update": "Quiz Sub Question Successfully Updated",
  "quizSubQuestion.delete": "Quiz Sub Question Successfully Deleted",

  "teacher.add": "Teacher Successfully Added",
  "teacher.update": "Teacher Successfully Updated",
  "teacher.delete": "Teacher Successfully Deleted",

  "ageGroupMaster.add": "Age Group Successfully Added",
  "ageGroupMaster.update": "Age Group Successfully Updated",
  "ageGroupMaster.delete": "Age Group Successfully Deleted",

  "assessment.add": "Self Assessment Successfully Added",
  "assessment.update": "Self Assessment Successfully Updated",
  "assessment.delete": "Self Assessment Successfully Deleted",

  "cmsContent.add": "CMS Content Successfully Added",
  "cmsContent.update": "CMS Content Successfully Updated",
  "cmsContent.delete": "CMS Content Successfully Deleted",

  "user.add": "User Successfully Added",
  "user.update": "User Successfully Updated",
  "user.delete": "User Successfully Deleted",

  //add,update,delete button text
  "add.taskMaster": "Add Task",
  "update.taskMaster": "Update Task",
  "delete.taskMaster": "Delete Task",

  "add.merchant": "Add Merchant",
  "delete.merchant": "Delete Merchant",
  "update.merchant": "Update Merchant",

  "add.ageGroupMaster": "Add Age Group",
  "update.ageGroupMaster": "Update Age Group",
  "delete.ageGroupMaster": "Delete Age Group",

  "add.quizQuestion": "Add Question ",
  "update.quizQuestion": "Update Quiz Question",
  "delete.quizQuestion": "Delete Quiz Question",

  "add.quizSubQuestion": "Add Sub Question ",
  "update.quizQuestion": "Update Sub Quiz Question",

  "add.teacher": "Add Teacher ",
  "update.teacher": "Update Teacher",
  "delete.teacher": "Delete Teacher",

  "add.assessment": "Add Self Assessment",
  "update.assessment": "Update Self Assessment",
  "delete.assessment": "Delete Self Assessment",

  "add.quizMaster": "Add Quiz",
  "update.quizMaster": "Update Quiz",
  "delete.quizMaster": "Delete Quiz",

  "add.school": "Add School",
  "update.school": "Update School",
  "delete.school": "Delete School",
  "name.school": "Name",
  "name.email": "Email",
  "school.add": "School Successfully Added",
  "school.update": "School Successfully Updated",
  "school.delete": "School Successfully Deleted",

  "add.cmsContent": "Add CMS Content",
  "update.cmsContent": "Update CMS Content",
  "delete.cmsContent": "Delete CMS Content",

  "add.user": "Add User",
  "view.user": "View User",
  "delete.user": "Delete User",
  "update.user": "Update User",

  //titles
  "title.quizMaster": "Quiz | uKiddiy",
  "title.taskMaster": "Task | uKiddiy",
  "title.assessmentMaster": "Self Assessment | uKiddiy",
  "title.ageGroupMaster": "Age Group | uKiddiy",
  "title.quizQuestion": "Quiz Questions | uKiddiy",
  "title.cmsContent": "CMS Content | uKiddiy",
  "title.merchant": "Merchant | uKiddiy",
  "title.teacher": "Teachers | uKiddiy",
  "title.school": "Schools | uKiddiy",

  number: "Number",
  videoLink: "Video Link",
  questionType: "Question Type",
  Image: "Image",
  s_no: "S No",
  quizQuestion: "afgs",
}
